import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { api } from "@/lib/api";
import ProfileCard from "@/components/ProfileCard";
import { Lock, Sparkles } from "lucide-react";

export default function Likes() {
  const [data, setData] = useState(null);

  const load = () => api.get("/likes/received").then(({ data }) => setData(data));
  useEffect(() => { load(); }, []);

  const like = async (p) => {
    await api.post(`/likes/${p.id}`);
    load();
  };

  if (!data) return <div className="pt-32 text-center text-text-muted">Loading…</div>;

  return (
    <div className="pt-24 pb-24 max-w-7xl mx-auto px-6">
      <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7 }}>
        <p className="text-xs uppercase tracking-[0.3em] text-gold mb-3">Admirers</p>
        <h1 className="font-display text-6xl font-light mb-4">Who's drawn to you</h1>
        <p className="text-text-muted mb-12">{data.count} member{data.count === 1 ? "" : "s"} admire you.</p>
      </motion.div>

      {!data.is_premium ? (
        <motion.div initial={{ opacity: 0 }} animate={{ opacity: 1 }}
          className="relative rounded-3xl border border-gold/30 overflow-hidden p-16 text-center bg-surface">
          <img src="https://images.unsplash.com/photo-1518893063132-36e46dbe2428?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200" alt="" className="absolute inset-0 w-full h-full object-cover opacity-15" />
          <div className="relative z-10">
            <Lock size={28} className="mx-auto text-gold mb-6" strokeWidth={1.5} />
            <h2 className="font-display text-4xl font-light mb-4">{data.count} admirers are waiting</h2>
            <p className="text-text-muted max-w-md mx-auto mb-8">Unlock Velluto Premium to reveal exactly who has admired you — and start the conversations you actually want.</p>
            <Link to="/premium" data-testid="likes-upgrade" className="inline-flex items-center gap-2 px-10 py-4 bg-gold text-ink rounded-full text-sm uppercase tracking-[0.2em] hover:bg-gold/90 transition-colors">
              <Sparkles size={16} /> Unlock with Premium
            </Link>
          </div>
        </motion.div>
      ) : data.admirers.length === 0 ? (
        <p className="text-text-muted font-display text-2xl italic">No admirers just yet — the night is young.</p>
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {data.admirers.map((p, i) => <ProfileCard key={p.id} profile={p} index={i} onLike={like} />)}
        </div>
      )}
    </div>
  );
}
